import { Button } from '@otp/ui';
import { Arrow } from '@otp/icons';
import { UserProfileMenu } from '../user-profile-menu';
import styles from './desktop.module.css';
import {
  Actions,
  AppArea,
  Subjects,
  User,
} from 'src/graphql/generated/graphql';
import UserNotificationsPopper from '../notification/user-notifications';
import { Can } from 'src/utils/can';
import GlobalSearchInput from '../search/global-search-input';

interface DesktopHeaderProps {
  user?: User;
  logout: () => void;
}

export const DesktopHeader = ({ user, logout }: DesktopHeaderProps) => {
  return (
    <div className={styles.wrapper}>
      <div style={{ height: 0, overflow: 'hidden' }}>
        <Button variant="outlined">
          Jump to &nbsp;
          <Arrow />
        </Button>
      </div>
      <div className={styles.searchWrapper}>
        <GlobalSearchInput />
      </div>
      <div className="ml-auto"></div>
      <Can I={Actions.Read} a={Subjects.Notifications} appArea={AppArea.Common}>
        <div className="mr-4 ml-4">
          <UserNotificationsPopper user={user} />
        </div>
      </Can>
      <UserProfileMenu user={user} logout={logout} />
    </div>
  );
};

export default DesktopHeader;
